<template>
  <div>
    <!-- <div><img :src="firstBanner" alt="" width="100%"></div> -->
    <h3 style="font-size:20px;padding-top:10px;color:#00ad48">Welcome to Exhibitor Service Platform!</h3>
    <el-card class="box-card">
      <div style="display:flex;">
        <div style="width:40%">
          <div class="text item"><span class="nameText">Company Name:</span> <span>{{ userInfo.atrEName }}</span></div>
          <div class="text item"><span class="nameText" >Booth Number:</span><span>{{ userInfo.bthCode || '暂无' }}</span></div>
          <div class="text item"><span class="nameText">Booth Size:</span>

            <template v-if="userInfo.bthArea">
              <span>{{userInfo.bthArea}} m<sup>2</sup></span>
            </template>
            <template v-else>
              <span>None</span>
            </template>
          </div>
          <div class="text item"><span class="nameText">Booth Type:</span> 
            <!-- <span>{{ userInfo.bthEnType }}</span> -->
            <span v-if="userInfo.bthBigType =='RS' || userInfo.bthBigType =='RS;RS'">RS(Raw Space)</span>
            <span v-if="userInfo.bthBigType =='SS' || userInfo.bthBigType =='SS;SS'">SS(Standard Booth)</span>
            <span v-if="userInfo.bthBigType =='SS;RS' || userInfo.bthBigType =='RS;SS'">RS(Raw Space);SS(Standard Booth)</span>
          </div>
        </div>
        <div>
          <div class="text item"><span class="nameText">Account Manager:</span><span>{{ userInfo.atrSaleEName || 'None' }}</span></div>
          <div class="text item"><span class="nameText">Tel:</span><span>(+86) {{ userInfo.atrTel || 'None' }}</span></div>
          <div class="text item"><span class="nameText">Email:</span><span>{{ userInfo.atrEmail || 'None' }}</span></div>
        </div>
      </div>
   
    </el-card>
    <ul>
      <li>
        <p style="font-weight:bold">We sincerely thank you for exhibiting in CAC2025 and its sub-exhibitions: CropProtection, FSHOW, CACE, AgTech.</p>
        <p>The Exhibitor Service Platform is now available to assist you in preparing for the exhibition. Services provided by the system include:</p>
        <ol style="font-weight:bold;padding:16px 0">
          <li @click="toLink('/magezine')">1.E-Catalogue entry </li>
          <li @click="toLink('/product')">2.Main Product</li>
          <li @click="toLink('/card')">3.Exhibitor Badge Application</li>
          <li @click="toLink('/inviteCode')">4.Company Invitation Card</li>
          <li @click="toLink('/hotel')">5.Hotel Reservation</li>
        </ol>
      </li>
      <li style="font-weight:bold">To ensure a smooth exhibition experience, please read the relevant information on the platform and adhere to the deadlines for each service. Please prioritize fields marked as "Required". If you have any questions, do not hesitate to contact your account manager for more comprehensive services and guidance.</li>
      <li style="font-weight:bold">We look forward to your arrival and wish you success at the exhibition!</li>
      <li style="font-weight:bold;color:red">To ensure the information is updated successfully, please click the save button immediately after making changes. If there is no activity for 60 minutes, the system will automatically log out.</li>
      <br />
      <div class="imporTip">Today is {{ today }}， Countdown {{ inDays }} Days</div>
    </ul>
    <el-divider></el-divider>
    <el-table :data="infoTable" style="width: 100%;padding-bottom:150px" stripe :span-method="objectSpanMethod">
      <el-table-column prop="fstName" label="Item" align="center">
        <template slot-scope="scope">
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-if="scope.row.fstName == '会刊信息' ">
              E-Catalogue Entry
          </span>
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-if="scope.row.fstName == '产品类别' ">
            Main Product 
          </span>
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-if="scope.row.fstName == '参展证申请' ">
            Exhibitor Badge Application
          </span>
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-if="scope.row.fstName == '新品上传' ">
            Product Image Upload
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Importance" align="center">
        <template slot-scope="scope">
          <span style="color:red">{{ scope.row.isRequired ? 'Required' : 'Not mandatory' }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="Status" align="center">
        <template slot-scope="scope">
          <!-- <span style="color:red">{{ scope.row.isRequired ? '已提交' : '未提交' }}</span> -->
          <span style="color:red">{{ scope.row.subDate ? 'Submitted' : 'Not submitted' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fstEDate" label="Instruction" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fstName == '参展证申请'"><!-- {{ format(scope.row.fstEDate) }} -->Please submit before March 16, 2025.</span>
          <span v-if="scope.row.fstName == '会刊信息' || scope.row.fstName == '新品上传' || scope.row.fstName == '产品类别'">Tips: CAC2025 will not provide print Catalogue. Instead, key products you submit or update will be included in the online E-Catalogue. The company name you submit for the E-Catalogue will be utilized for the exhibitor list, which will be featured on our official website, in the on-site exhibitor list, and on your booth fascia. The deadline for exhibitor list/booth fascia is February 20, 2025.</span>
          <!-- <span v-if="scope.row.fstName == '产品类别'">Tips: CAC2025 will no longer provide print Catalogue. Instead, key products you submit or update will be included in the online E-Catalogue. You can access the latest product information anytime, anywhere through our official website, social media platforms, and the mobile mini-app.</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="subDate" label="Submission Date" align="center">
        <template slot-scope="scope">
          <span>{{ format(scope.row.subDate) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import moment from 'moment'
import firstBanner from '@/assets/firstBanner.jpg'
import tools from '@/utils/tools';
moment.locale('zh-cn')
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      exhInfo: {},
      today:'' ,
      inDays: '',
      infoTable: [],
      firstBanner:firstBanner,
      month:['January','February','March','April','May','June','July','August','September','October','November','December']
    }
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //当前行row、当前列column、当前行号rowIndex、当前列号columnIndex
      if (columnIndex === 2) {
        if (rowIndex === 1) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex === 2 || rowIndex === 3) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    toLink(url){
      // console.log(url)
      this.$router.push(url)
    },
    tableLink(obj){
      var url = ''
      if(obj.fstName == '会刊信息'){
        url = '/magezine'
      }
      if(obj.fstName == '产品类别'){
        url = '/product'
      }
      if(obj.fstName == '参展证申请'){
        url = '/card'
      }
      if(obj.fstName == '新品上传'){
        url = '/productList'
      }
      this.$router.push(url)
    }
  },
  mounted() {

    var _tempDay = moment().format('YYYY/M/DD')
    
    _tempDay = _tempDay.split('/')
    // console.log(_tempDay[1])
    // console.log(this.month[11])
    this.today = this.month[parseInt(_tempDay[1]-1)]+" "+ _tempDay[2]+", "+ _tempDay[0]

    api.getexhinfo().then((res) => {
      // this.inDays = moment(res.data.data.exhbtime).toNow(true)
      this.inDays = moment(res.data.data.exhbtime).diff(new Date(), 'day')
      // console.log(moment(res.data.data.exhbtime).diff(new Date(), 'month','day'))
      // console.log(moment('2024-03-01 00:00:00').diff(new Date(), 'month','day'))
    })

    api.getformsetting().then((res) => {
      var _temp = res.data.data
      this.infoTable =  _temp // .sort(function(data1,data2){
  //       if(new Date(data1.fstEDate).getTime() > new Date(data2.fstEDate).getTime()){
  //         return 1
  //       }else{
  //         return -1
  //       }
  
  //     })
      // this.infoTable = _temp
      // console.log(this.infoTable )

    })
  },

}
</script>

<style lang="less" scoped>
.box-card {
  margin: 20px 0 20px 0;
}
.item {
  padding: 10px 0;
  font-size:14px
}
.item .nameText{
  font-weight: normal;
  display: inline-block;
  width:120px;
  text-align:left;
  margin-right: 10px;
}
.item span{
  font-weight: bold;
}
li, strong {
  line-height: 2;
  font-size:14px;
}
.page-warp h3{
  font-size:14px
}
.imporTip{
  padding:10px 20px;font-size:18px;color:#00ad48;font-weight: bold;
  background: #d0eadb linear-gradient(135deg, #d0eadb 0%, #fff 100% );
  border-radius:10px;
}
li{
  cursor: pointer;
}
@media screen and (max-width:540px){

}
</style>
